import app from './modules/app/types'

export default {
  app
}



// WEBPACK FOOTER //
// ./src/store/types.js